import productInfo from './productInfo'
import productType from './productType'
import productTradeMark from './productTradeMark'
import productAttribute from './productAttribute'
import designer from './designer'

export default {
  pmc: {
    product: {
      ...productInfo,
      ...productType,
      ...productTradeMark,
      ...productAttribute,
      ...designer
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/pmc/pmc.js